import React from 'react';
import { formatDate, localizedValue } from './nationalizationViewModel';

export default function NationalizationCalculationChanges({ changes = [], language, t }) {
  const items = Array.isArray(changes) ? changes : [];
  if (!items.length) return null;

  return (
    <section className="nationalization-calculation-changes" aria-label={t('notifications.recentChanges', 'Recent nationalization changes')}>
      {items.map((change, index) => (
        <article key={change.change_id || `${change.code || 'change'}-${index}`}>
          <i className="fa-solid fa-bell" aria-hidden="true" />
          <div>
            <strong>{localizedValue(change, language, 'title') || t('notifications.resultChangedTitle', 'Your nationalization result changed')}</strong>
            <p>{localizedValue(change, language, 'message') || change.code}</p>
            {change.created_at && <small>{formatDate(change.created_at, language)}</small>}
          </div>
        </article>
      ))}
    </section>
  );
}
